@let overlayVisible = layoutFacade.displayOverlay$ | async;
@let notification = layoutFacade.notificationMessage$ | async;
@let blackOverlayVisible = layoutFacade.blackOverlayVisible$ | async;
@if (overlayVisible) {
    <div
        class="overlay"
        [class.black-overlay]="blackOverlayVisible && !notification?.message"
        (keypress)="lockApp($event)"
        (click)="lockApp($event)">
        <h-overlay-error-message></h-overlay-error-message>
    </div>
}
